package example.shadcn_kotlin.ui.pages.docs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobwebx.markdown.*
import example.shadcn_kotlin.ui.components.*
import example.shadcn_kotlin.ui.docs.installation.AutomaticInstallationSteps
import example.shadcn_kotlin.ui.docs.installation.ManualInstallationSteps

@Page
@Composable
fun InstallationPage() {
    CompositionLocalProvider(LocalMarkdownContext provides MarkdownContext("docs/installation.md", mapOf("title" to listOf("Installation"), "description" to listOf("How to install dependencies and structure your app.")))) {
        example.shadcn_kotlin.ui.components.layouts.MDLayout {
            org.jetbrains.compose.web.dom.P({ classes("leading-7","[&:not(:first-child)]:mt-6") }) {
                org.jetbrains.compose.web.dom.Text("Unlike the official ")
                org.jetbrains.compose.web.dom.A("https://ui.shadcn.com", { classes("font-medium","underline","underline-offset-4") }) {
                    org.jetbrains.compose.web.dom.Text("shadcn/ui")
                }
                org.jetbrains.compose.web.dom.Text(" for React, where the components can be added by cli, here we need to just add a dependency in build.gradle to add all of them.")
            }
            org.jetbrains.compose.web.dom.H2({ 
classes("font-heading","mt-12","scroll-m-20","border-b","pb-2","text-2xl","font-semibold","tracking-tight","first:mt-0")
id("automatic-installation")
 }) {
                org.jetbrains.compose.web.dom.Text("Automatic Installation")
            }
            AutomaticInstallationSteps()
            org.jetbrains.compose.web.dom.P({ classes("leading-7","[&:not(:first-child)]:mt-6") }) {
                org.jetbrains.compose.web.dom.Text("That's it. You can now run the site through ")
                org.jetbrains.compose.web.dom.Code({ classes("bg-muted","py-[0.2rem]","px-[0.3rem]","rounded","text-sm") }) {
                    org.jetbrains.compose.web.dom.Text("kobweb run")
                }
            }
            org.jetbrains.compose.web.dom.H2({ 
classes("font-heading","mt-12","scroll-m-20","border-b","pb-2","text-2xl","font-semibold","tracking-tight","first:mt-0")
id("manual-installation")
 }) {
                org.jetbrains.compose.web.dom.Text("Manual Installation")
            }
            ManualInstallationSteps()
            org.jetbrains.compose.web.dom.P({ classes("leading-7","[&:not(:first-child)]:mt-6") }) {
                org.jetbrains.compose.web.dom.Text("That's it. You can now use shadcn components in your project.")
            }
        }
    }
}
